import { useContext } from 'react';
import {
  ResponsiveContext,
  ResponsiveInfo,
} from '../components/providers/ResponsiveProvider/index';

export const useResponsive = (): ResponsiveInfo => {
  return useContext(ResponsiveContext);
};
